export default __webpack_public_path__ + "static/media/suntek_ultra.419681f5.jpg";